<template>
  <div class="pavilion-button" @click="handleClick">
    <img class="detail-button-icon" :src="imageUrl" alt="">
    <div class="detail-button-text">{{ text }}</div>
    <!--suppress HtmlUnknownTag -->
    <wx-open-launch-weapp
      v-if="canGoMp"
      ref="openBtn"
      class="wx-open-launch-weapp"
      :username="username"
      :path="pavilion.appUrl || '/pages/index/index'"
    >
      <!-- 必须写：占位的按钮 -->
      <script type="text/wxtag-template">
        <style>
          .ctn {
            width: 120px;
            height: 40px;
          }
        </style>
        <div class="ctn"></div>
      </script>
    </wx-open-launch-weapp>
  </div>
</template>

<script>
import { isWeChat, isWeChatMiniProgram } from '@/utils/env'
import pavilionClick from '@/mixins/pavilion-click.js'

export default {
  name: 'PavilionButton',
  props: {
    imageUrl: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    toMp: {
      type: Boolean,
      default: false,
    },
    pavilion: {
      type: Object,
      default: () => ({}),
    },
  },
  mixins: [pavilionClick],
  computed: {
    canGoMp () {
      return this.toMp && this.pavilion.appId && isWeChat() && !isWeChatMiniProgram()
    },
    username () {
      const { appId, originalAppId } = this.pavilion
      return originalAppId || appId
    },
  },
}
</script>

<style lang="less" scoped>
.wx-open-launch-weapp {
  z-index: 1;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: transparent;
}

.pavilion-button {
  position: relative;
  width: 3.6rem;
  height: 0.88rem;
  padding: 0 0.3rem;
  background-image: linear-gradient(180deg, #ffa730 0%, #ff710b 100%);
  border-radius: 0.44rem;
  display: flex;
  align-items: center;
  justify-content: center;

  .detail-button-icon {
    margin-right: 0.1rem;
    width: 0.4rem;
    height: 0.4rem;
    object-fit: contain;
  }
}

.detail-button-text {
  font-family: PingFang-SC-Bold;
  font-weight: bold;
  font-size: 0.36rem;
  color: #ffffff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
